export default {
	// url: "http://localhost:55490/api/v0/",
	// tokenService: "http://localhost:55490/token",

	url: process.env.VUE_APP_ROOT_API,
	tokenService: process.env.VUE_APP_ROOT_API_TOKEN,
}
